import React, { useLayoutEffect, useState } from "react";
import CloseButton from "../close-button/close-button";
import { StyledCloseContainer } from "./close-container.styles";

const CloseContainer = () => {
  const [origWidth, setOrigWidth] = useState(207);

  useLayoutEffect(() => {
    if (typeof window === "undefined") return;
    const basketButton = document.querySelector("#header-basket");
    setOrigWidth(basketButton?.parentElement?.clientWidth || 207); // width block with 3 icons inside which placed in the right from Search field in header
  }, []);

  return (
    <StyledCloseContainer originalWidth={origWidth}>
      <CloseButton dataTestId="search-close-button-desktop" />
    </StyledCloseContainer>
  );
};

export default React.memo(CloseContainer);
